export default __webpack_public_path__ + "static/media/enhanced-retirement-sum-mobile.5e66a8a4.svg";